export default __webpack_public_path__ + "static/media/WOC_Podcasters_Logo.529bfa8f.png";